/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Development_TitleInputs */

const et_service_development_title = /** @type {(inputs: Service_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodulehe arendus, parandus ja hooldus`)
};

const en_service_development_title = /** @type {(inputs: Service_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website Development, Improvement & Maintenance`)
};

/**
* | output |
* | --- |
* | "Website Development, Improvement & Maintenance" |
*
* @param {Service_Development_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_development_title = /** @type {((inputs?: Service_Development_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Development_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_development_title(inputs)
	return en_service_development_title(inputs)
});